var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-image blue"},[_vm._v("\n  "+_vm._s(_vm.dragSelected ? _vm.selectedCount : '1')+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }